export const Logo = ({ compact = false }) => (
  <a href="/" className="flex items-center group shrink-0" data-testid="brand-logo" aria-label="Haven & Hill Properties — home">
    <img
      src="/logo.png"
      alt="Haven & Hill Properties"
      className={`${compact ? "h-14" : "h-16 sm:h-20"} w-auto transition-transform duration-300 group-hover:scale-[1.04]`}
    />
  </a>
);
